import { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getGuildFromPath, toGuildPath } from "./guildUtils";

export function useGuild() {
  const { pathname } = useLocation();

  return useMemo(() => getGuildFromPath(pathname), [pathname]);
}

export function useGuildPath() {
  const guild = useGuild();

  return useCallback((path) => toGuildPath(path, guild), [guild]);
}
